import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Onboarding from "@/pages/Onboarding";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppLayout from "@/pages/AppLayout";
import Home from "@/pages/Home";
import Results from "@/pages/Results";
import History from "@/pages/History";
import Profile from "@/pages/Profile";
import Verify from "@/pages/Verify";
import ForgotPasswordPrueba from "@/pages/ForgotPasswordPrueba";

const PublicGate = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicGate><Onboarding /></PublicGate>} />
            <Route path="/login" element={<PublicGate><Login /></PublicGate>} />
            <Route path="/register" element={<PublicGate><Register /></PublicGate>} />
            <Route path="/recuperar-password" element={<PublicGate><ForgotPasswordPrueba /></PublicGate>} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/verify/:hash" element={<Verify />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Home />} />
              <Route path="resultado/:id" element={<Results />} />
              <Route path="historial" element={<History />} />
              <Route path="perfil" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#1F2228",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
